// ─── FILL THESE IN AFTER RUNNING deploy.sh ───────────────────────────────────
// Values come from the CloudFormation stack outputs

const config = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT || 'https://YOUR_API_ID.execute-api.us-east-1.amazonaws.com/prod',
  cognito: {
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_XXXXXXXXX',
    clientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || 'XXXXXXXXXXXXXXXXXXXXXXXXXX',
  },
};

export default config;
